// extracted by mini-css-extract-plugin
module.exports =  {"errors":"errors--MIK_W","error":"error--zscn9","solid":"solid--HxTcY"};